export default __webpack_public_path__ + "static/media/home-sold-faded.4d9695da.jpg";